import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
const BACKEND_URL = process.env.REACT_APP_API_URL || 'https://vigilantapp.duckdns.org'

export default function AlertAction() {
  const { deviceId } = useParams<{ deviceId: string }>()
  const navigate = useNavigate()
  const [done, setDone] = useState<'ok' | 'help' | null>(null)
  const [loading, setLoading] = useState(false)

  async function handleAction(action: 'ok' | 'help') {
    setLoading(true)
    try {
      await fetch(`${BACKEND_URL}/api/notifications/action`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, deviceId }),
      })
    } catch {
      // ignoruj chybu siete
    }
    setDone(action)
    setLoading(false)
  }

  if (done === 'ok') {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.icon}>✅</div>
          <h2 style={styles.title}>V poriadku</h2>
          <p style={styles.body}>Situácia je pod kontrolou.</p>
          <button style={styles.btnSecondary} onClick={() => navigate('/dashboard')}>
            Späť na dashboard
          </button>
        </div>
      </div>
    )
  }

  if (done === 'help') {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.icon}>🆘</div>
          <h2 style={styles.title}>Pomoc vyžiadaná</h2>
          <p style={styles.body}>Prosím okamžite skontrolujte situáciu a zavolajte pomoc.</p>
          <button style={styles.btnSecondary} onClick={() => navigate('/dashboard')}>
            Späť na dashboard
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>⚠️</div>
        <h2 style={styles.title}>Senior neaktívny</h2>
        <p style={styles.body}>Senior je dlhšiu dobu bez pohybu. Ako reagujete?</p>
        <button
          style={{ ...styles.btnOk, opacity: loading ? 0.6 : 1 }}
          disabled={loading}
          onClick={() => handleAction('ok')}
        >
          ✅ Je to OK
        </button>
        <button
          style={{ ...styles.btnHelp, opacity: loading ? 0.6 : 1 }}
          disabled={loading}
          onClick={() => handleAction('help')}
        >
          🆘 Volaj pomoc
        </button>
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0f172a',
    padding: '24px',
  },
  card: {
    background: '#1e293b',
    borderRadius: '16px',
    padding: '40px 32px',
    maxWidth: '360px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
  },
  icon: {
    fontSize: '56px',
    marginBottom: '16px',
  },
  title: {
    color: '#f1f5f9',
    fontSize: '22px',
    fontWeight: 700,
    margin: '0 0 12px',
  },
  body: {
    color: '#94a3b8',
    fontSize: '15px',
    marginBottom: '32px',
    lineHeight: 1.5,
  },
  btnOk: {
    display: 'block',
    width: '100%',
    padding: '14px',
    borderRadius: '10px',
    border: 'none',
    background: '#22c55e',
    color: '#fff',
    fontSize: '17px',
    fontWeight: 600,
    cursor: 'pointer',
    marginBottom: '12px',
  },
  btnHelp: {
    display: 'block',
    width: '100%',
    padding: '14px',
    borderRadius: '10px',
    border: 'none',
    background: '#ef4444',
    color: '#fff',
    fontSize: '17px',
    fontWeight: 600,
    cursor: 'pointer',
    marginBottom: '12px',
  },
  btnSecondary: {
    display: 'block',
    width: '100%',
    padding: '12px',
    borderRadius: '10px',
    border: '1px solid #334155',
    background: 'transparent',
    color: '#94a3b8',
    fontSize: '15px',
    cursor: 'pointer',
    marginTop: '8px',
  },
}
